<template>
  <header class="project-tree-header" :class="{'project-tree-header_full': activeZoom}">
    <h2 class="title">
      {{$t('projects.project.structure')}}
    </h2>
    <div class="header-right" v-if="isAdminRole">
      <p class="add-section">
        {{$t('projects.project.addSection')}}
      </p>
      <button type="button"
              @click="addSection"
              class="btn-main-plus">
        <plus-icon></plus-icon>
      </button>
    </div>
  </header>
</template>

<script>
  import plusIcon from '../../../Svg/plusIcon'
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import {showOverlay} from "../../../../mixins/utils/showOverlay";
  import {singleProject} from "../../../../mixins/projects/singleProject";

  export default {
    name: 'projectTreeHeader',
    mixins: [showOverlay, singleProject],
    components: {
      plusIcon
    },
    computed: {
      ...mapState({
        activeZoom: state => state.projects.activeZoom,
      }),
      ...mapGetters({
        isAdminRole: 'auth/adminRole',
      }),
    },
    methods: {
      ...mapMutations({
        showAddSection: 'projects/SET_SHOW_ADD_SECTION',
        setAddId: 'projects/SET_ADD_SECTION_ID_CHILD'
      }),
      addSection() {
        this.showOverlay(true);
        this.showAddSection(true);
        addIdSection(this);

        function addIdSection(cntx) {
          const itemId = cntx.$route.params.item;
          if (itemId) {
            cntx.setAddId(itemId)
          };
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .project-tree-header {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;
  }

  .project-tree-header_full {
    margin-bottom: 0;
    padding-top: 14px;
    padding-bottom: 14px;
    padding-left: 14px;
    padding-right: 14px;
  }

  .title {
    font-family: $msb;
    font-size: 18px;
    letter-spacing: .25px;
  }

  .add-section {
    font-family: $mm;
    font-size: 14px;
    opacity: .6;
    margin-right: 25px;
  }

  .header-right {
    display: flex;
    align-items: center;
  }
</style>
